// extracted by mini-css-extract-plugin
module.exports = {"NotesControls":"NotesControls_NotesControls__Xitkl","contBtns":"NotesControls_contBtns__23y9k"};